import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class SifarnikProcesiService {
  constructor(private _http: HttpClient) {}

  dohvatiSveProcese(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_proces', a)
      .pipe(map((res: any) => res));
  }

  addProcess(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'proces_add', a)
      .pipe(map((res: any) => res));
  }

  editProcess(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'proces_edit', a)
      .pipe(map((res: any) => res));
  }

  deleteProces(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'obrisi_proces', a)
      .pipe(map((res: any) => res));
  }

  pravaKorisnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prijavaprava', a)
      .pipe(map((res: any) => res));
  }
}
